import Box from '@/common/components/Box'
import Spinner from '@/common/components/Spinner'
import { ImageCarousel } from '@/common/components/ImageCarousel'
import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { ImageIcon, Inbox } from 'lucide-react'
import { useMaintenanceWorkflowSolicitations } from '../../../hooks/useMaintenanceWorkflowSolicitations'
import { MaintenanceWorkflowSolicitationData } from '../../../types/maintenanceManualEntryProposal.type'

type Props = {
  workflowId: string | undefined
}

const ProposalSolicitations = ({ workflowId }: Props) => {
  const { data: solicitations, isLoading, isError } = useMaintenanceWorkflowSolicitations<MaintenanceWorkflowSolicitationData[]>({
    workflowId,
  })

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm font-medium">Solicitações</p>

      {isLoading ? (
        <div className="flex items-center justify-center py-6">
          <Spinner className="h-5 w-5 fill-blue-800" />
        </div>
      ) : isError || solicitations.length === 0 ? (
        <div className="flex flex-col items-center justify-center gap-2 py-6 text-center">
          <Inbox className="size-7 text-white-300" strokeWidth={1.5} />
          <p className="text-xs text-white-400">Nenhuma solicitação neste processo.</p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {solicitations.map((solicitation) => (
            <Box key={solicitation.id} className="p-3 flex flex-col gap-2">
              <p className="text-sm font-bold">{solicitation.protocol_number || '--'}</p>

              {(solicitation.photos?.length || solicitation.observations) && (
                <div className="flex items-start gap-3">
                  {solicitation.photos && solicitation.photos.length > 0 && (
                    <ImageCarousel
                      files={solicitation.photos
                        .filter((photo) => !!photo?.url)
                        .map((photo) => ({ id: photo.url as string, file: photo.url as string }))}
                      Placeholder={
                        <ImageWithPlaceholder className="size-24 rounded-md" iconClassName="size-10" placeholderIcon={ImageIcon} />
                      }
                      className="size-24 shrink-0"
                      showExpandButton
                      showNavigationButtons={false}
                      showRemoveButton={false}
                    />
                  )}

                  {solicitation.observations && (
                    <p className="flex-1 text-xs text-white-800">{solicitation.observations}</p>
                  )}
                </div>
              )}

              {solicitation.objectives.length > 0 && (
                <div className="flex flex-col gap-0.5 border-t border-white-200 pt-2">
                  {solicitation.objectives.map((objective) => (
                    <p key={objective.id} className="text-[11px] text-white-400">
                      {[objective.action?.display_name, objective.part?.display_name, objective.system?.display_name]
                        .filter(Boolean)
                        .join(' • ')}
                    </p>
                  ))}
                </div>
              )}
            </Box>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProposalSolicitations
